// components/projects/ProjectsSkeleton.tsx
import React from "react";

const ProjectsSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 animate-pulse">
      {/* Page Header Skeleton */}
      <div className="mb-6">
        <div className="h-8 w-32 bg-gray-200 rounded-lg mb-2" />
        <div className="h-4 w-48 bg-gray-200 rounded-lg" />
      </div>

      {/* Main Content Card Skeleton */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        {/* Tabs and Search Bar Skeleton */}
        <div className="p-4 sm:p-6 border-b border-gray-100">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            {/* Tabs Skeleton */}
            <div className="flex items-center gap-2 p-1 bg-gray-100 rounded-xl">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-10 w-28 bg-gray-200 rounded-lg" />
              ))}
            </div>

            {/* Search and Filter Skeleton */}
            <div className="flex items-center gap-3">
              <div className="h-10 w-64 bg-gray-200 rounded-xl" />
              <div className="h-10 w-10 bg-gray-200 rounded-xl" />
            </div>
          </div>
        </div>

        {/* Projects Grid Skeleton */}
        <div className="p-4 sm:p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div
                key={i}
                className="bg-white rounded-xl border border-gray-200 overflow-hidden"
              >
                <div className="p-4">
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="h-6 w-24 bg-gray-200 rounded-full" />
                    <div className="h-6 w-16 bg-gray-200 rounded-lg" />
                  </div>
                  <div className="h-6 w-3/4 bg-gray-200 rounded-lg mb-2" />
                  <div className="h-4 w-full bg-gray-200 rounded-lg mb-1" />
                  <div className="h-4 w-2/3 bg-gray-200 rounded-lg mb-4" />
                </div>
                <div className="px-4 pb-4">
                  <div className="h-12 w-full bg-gray-200 rounded-xl" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsSkeleton;
